import { findThumbnail } from '@marketplace-web/shared/utils'

import { MAXIMUM_PHOTO_HEIGHT, MAXIMUM_PHOTO_WIDTH, RESIZED_PHOTO_QUALITY } from '../constants'

export const getPhotoThumbnail = findThumbnail

export const resizePhoto = (file: File): Promise<File> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (event: ProgressEvent<FileReader>) => {
      const img = new Image()

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        let { width, height } = img

        if (width > MAXIMUM_PHOTO_WIDTH || height > MAXIMUM_PHOTO_HEIGHT) {
          const widthRatio = MAXIMUM_PHOTO_WIDTH / width
          const heightRatio = MAXIMUM_PHOTO_HEIGHT / height
          const scalingFactor = Math.min(widthRatio, heightRatio)

          width *= scalingFactor
          height *= scalingFactor
        }

        canvas.width = width
        canvas.height = height

        const dx = 0
        const dy = 0

        ctx?.drawImage(img, dx, dy, width, height)

        canvas.toBlob(
          (blob: Blob | null) =>
            blob
              ? resolve(new File([blob], file.name, { type: blob.type }))
              : reject(new Error('Error while generating blob')),
          file.type,
          RESIZED_PHOTO_QUALITY,
        )
      }

      img.onerror = () => {
        // If the image fails to load, we resolve with the original file
        resolve(file)
      }

      img.src = event.target?.result as string
    }

    reader.readAsDataURL(file)
  })

export const createPhotoFormData = (file: File, type: string, tempUuid?: string): FormData => {
  const formData = new FormData()

  formData.append('photo[type]', type)
  formData.append('photo[file]', file)

  if (tempUuid) {
    formData.append('photo[temp_uuid]', tempUuid)
  }

  return formData
}
